module.exports = __webpack_public_path__ + "img/stars-simple.edc316ec.jpg";